import mitt from 'mitt';
const emitter = mitt();
/**
 * EventBus is a simple event bus for Nuxt 3 applications. It allows components to communicate with
 * each other by emitting and listening to events. It is based on the mitt library, which is a tiny
 * functional event emitter. It is not meant to be used for complex state management, but rather for
 * simple event handling and communication between components.
 *
 * NOTE: This is a client-side only event bus. It will not work on the server side.
 */
export const EventBus = {
    $on: (type, handler) => {
        if (import.meta.server) {
            console.debug('EventBus is not available on the server side.');
            return;
        }
        emitter.on(type, handler);
    },
    $emit: (type, evt) => {
        if (import.meta.server) {
            console.debug('EventBus is not available on the server side.');
            return;
        }
        emitter.emit(type, evt);
    },
    $off: (type, handler) => {
        if (import.meta.server) {
            console.debug('EventBus is not available on the server side.');
            return;
        }
        emitter.off(type, handler);
    },
    $clearAll: () => emitter.all.clear()
};
export default EventBus;
//# sourceMappingURL=index.js.map